import lowerCase from 'lodash/lowerCase';
import { arrayOf, shape, string } from 'prop-types';
import React from 'react';

import FlagIcon from '../../generic/FlagIcon';

function QuoteLineCountryTableHeaders({ countries }) {
  return (
    <>
      <th>&nbsp;</th>
      <th>∑</th>
      {countries.map(({ label }) => (
        <th key={label} className="c-quote-line-table__column--currency">
          {label}
          <FlagIcon
            code={label === 'UK' ? 'gb' : lowerCase(label)}
            className="ml-2"
          />
        </th>
      ))}
    </>
  );
}

QuoteLineCountryTableHeaders.propTypes = {
  countries: arrayOf(
    shape({ countryCode: string.isRequired, label: string.isRequired }),
  ).isRequired,
};

export default QuoteLineCountryTableHeaders;
